// update along with app/lib/enums/product_type.py
const ProductType = {
  MANUFACTURER: 'manufacturer',
  DISTRIBUTOR: 'distributor',
  GLOBAL: 'global',
};

const ProductTypeDisplay = {
  MANUFACTURER: 'Manufacturer',
  DISTRIBUTOR: 'Distributor',
};

const ProductTypeOptions = [
  { value: ProductType.MANUFACTURER, label: 'Manufacturer' },
  { value: ProductType.DISTRIBUTOR, label: 'Distributor' },
];

const ProductTypeDisplayOptions = [
  { value: ProductTypeDisplay.MANUFACTURER, label: 'Manufacturer' },
  { value: ProductTypeDisplay.DISTRIBUTOR, label: 'Distributor' },
];

const GLOBAL_PRODUCT_TYPE = 'global';

export {
  ProductType,
  ProductTypeDisplay,
  ProductTypeOptions,
  ProductTypeDisplayOptions,
  GLOBAL_PRODUCT_TYPE,
};
